module.exports = __webpack_public_path__ + "static/media/s1Logo.dbd37871.png";